define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools"], function (require, exports, $, ko, log, urls_1, tools) {
    "use strict";
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    var Login = /** @class */ (function () {
        function Login() {
            this.Email = ko.observable();
            this.Password = ko.observable();
            this.RememberMe = ko.observable(false);
            this.VerifyCode = ko.observable(false);
            this.Provider = ko.observable(null);
            this.ForgotEmail = ko.observable();
            this.HasError = ko.observable(false);
            this.Error = ko.observable();
            this.HasNotification = ko.observable(false);
            this.Notification = ko.observable();
        }
        Login.prototype.init = function () {
            var self = this;
            //self.Email($("#sign-in__email").val());
            //self.Password($("#sign-in__password").val());
            ko.applyBindings(self, document.getElementById("ko-main-content"));
        };
        Login.prototype.onEnterDoLogin = function (d, e) {
            e.keyCode === 13 && this.doLogin();
            return true;
        };
        Login.prototype.doLogin = function () {
            var self = this;
            self.Email($("#sign-in__email").val());
            self.Password($("#sign-in__password").val());
            self.HasNotification(false);
            self.HasError(false);
            self.Error("");
            var obj = ko.mapping.toJS({
                Email: self.Email,
                Password: self.Password,
                RememberMe: self.RememberMe
            });
            if (!regex.test(obj.Email) || !obj.Email) {
                self.HasError(true);
                self.Error("Please enter a valid email address.");
                return;
            }
            $(".js-login").button("loading");
            tools.ajaxPost({
                url: "/Account/LoginAjax",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    if (result.Data.returnUrl === 'VerifyCode') {
                        self.VerifyCode(true);
                        setTimeout(function () {
                            $('#sign-in__code').focus();
                        });
                    }
                    else {
                        window.location.href = result.Data.returnUrl;
                    }
                }
                else {
                    if (result.Error) {
                        self.Error(result.Error);
                    }
                    else {
                        self.Error("Unknown error occurred.");
                    }
                    self.HasError(true);
                    return;
                }
            }).always(function () {
                $(".js-login").button("reset");
            });
        };
        Login.prototype.do2FALogin = function () {
            var self = this;
            var verificationCode = $("#sign-in__code").val();
            self.HasNotification(false);
            self.HasError(false);
            self.Error("");
            var obj = ko.mapping.toJS({
                pin: verificationCode,
                provider: self.Provider()
            });
            if (!obj.pin) {
                self.HasError(true);
                self.Error("Please enter a valid email address.");
                return;
            }
            $(".js-login").button("loading");
            tools.ajaxPost({
                url: "/Account/VerifyCode",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    window.location.href = result.Data.returnUrl;
                }
                else {
                    if (result.Error) {
                        self.Error(result.Error);
                    }
                    else {
                        self.Error("Unknown error occurred.");
                    }
                    self.HasError(true);
                    return;
                }
            }).always(function () {
                $(".js-login").button("reset");
            });
            ;
            return;
        };
        Login.prototype.doResendSMS = function () {
            var self = this;
            self.HasNotification(false);
            self.HasError(false);
            self.Error("");
            $(".js-sendsms").button("loading");
            tools.ajaxGet({
                url: "/Account/SendTwoFactorCode?provider=PhoneCode"
            }).done(function (result) {
                if (result.Success) {
                    if (result.Data.returnUrl) {
                        tools.error("Your login session already expired");
                        window.location.href = result.Data.returnUrl;
                    }
                    else {
                        tools.success("Code sent successfully");
                        self.Provider("PhoneCode");
                    }
                }
                else {
                    if (result.Error) {
                        self.Error(result.Error);
                    }
                    else {
                        self.Error("Unknown error occurred.");
                    }
                    self.HasError(true);
                    return;
                }
            }).always(function () {
                $(".js-sendsms").button("reset");
            });
        };
        Login.prototype.doResendEmail = function () {
            var self = this;
            self.HasNotification(false);
            self.HasError(false);
            self.Error("");
            $(".js-sendemail").button("loading");
            tools.ajaxGet({
                url: "/Account/SendTwoFactorCode?provider=EmailCode"
            }).done(function (result) {
                if (result.Success) {
                    if (result.Data.returnUrl) {
                        tools.error("Your login session already expired");
                        window.location.href = result.Data.returnUrl;
                    }
                    else {
                        tools.success("Code sent successfully");
                        self.Provider("EmailCode");
                    }
                }
                else {
                    if (result.Error) {
                        self.Error(result.Error);
                    }
                    else {
                        self.Error("Unknown error occurred.");
                    }
                    self.HasError(true);
                    return;
                }
            }).always(function () {
                $(".js-sendemail").button("reset");
            });
        };
        Login.prototype.doResetPassword = function () {
            var self = this;
            self.HasNotification(false);
            self.HasError(false);
            self.Error("");
            var obj = ko.mapping.toJS({
                Email: self.ForgotEmail
            });
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            if (!regex.test(obj.Email) || !obj.Email) {
                self.HasError(true);
                self.Error("Please enter a valid email address.");
                return;
            }
            $(".js-reset-password").button("loading");
            tools.ajaxPost({
                url: "/Account/ForgotPassword",
                data: obj
            }).done(function (result) {
                if (result.Data && result.Data.RegisterSuccess) {
                    self.HasNotification(true);
                    self.Notification("Please check your email. We've sent you a link to a page where you can create a new password.");
                }
                else {
                    if (result.Data && result.Data.Error != null) {
                        self.Error(result.Data.Error);
                    }
                    else {
                        self.Error("Unknown error occurred.");
                    }
                    self.HasError(true);
                    return;
                }
            }).always(function () {
                $(".js-reset-password").button("reset");
            });
        };
        return Login;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Account/Login")) {
            log.log("Initialize login");
            $(function () {
                (new Login()).init();
            });
        }
    }, 0);
    return Login;
});
//# sourceMappingURL=login.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/account/login.js
// module id = 285
// module chunks = 2